import { Button, CardContent, Grid, Typography, Alert } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import PaperComponent from "../paper-component"

const DisplayResultDialog = ({ open, isSuccess, message, title, fileName, onClose, onConfirm }) => {
  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {`Import ${title}`}
      </DialogTitle>
      <DialogContent dividers>
        <CardContent>
          <Grid container spacing={3} style={{ textAlign: "center" }}>
            {!isSuccess && (
              <Grid item md={12} xs={12}>
                <Alert severity="error" style={{ marginBottom: 8 }}>
                  <div dangerouslySetInnerHTML={{ __html: message }}></div>
                </Alert>
              </Grid>
            )}

            <Grid item md={12} xs={12}>
              {isSuccess ? (
                <>
                  <Typography color="textPrimary" gutterBottom variant="h5">
                    {message}
                  </Typography>
                  <Typography color="textPrimary" gutterBottom>
                    Would you like to import another file?
                  </Typography>
                </>
              ) : (
                <>
                  <Typography color="textPrimary" gutterBottom>
                    <div dangerouslySetInnerHTML={{ __html: `Do you want to try import <b>${fileName}</b> again? Please note that only failed items will be retried.` }}></div>
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="info" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained">
          {isSuccess ? "Import New File" : "Retry"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DisplayResultDialog
